"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils_1 = require("./utils");
var globals_1 = require("./globals");
var eventbody_1 = require("./eventbody");
var logger_1 = require("./logger");
var logLevel_1 = require("./logLevel");
var Event = /** @class */function () {
  function Event(name, body) {
    this.header = {
      name: "",
      player_id: null,
      s_session_id: null,
      game_ver: "",
      app_token: "",
      platform: globals_1.default.platform,
      env: "dev",
      device_id: "",
      c_session_id: "",
      uuid: utils_1.default.uuidv4(),
      timezone: new Date().toString().split("GMT")[1].split(" (")[0],
      ts: "",
      timestamp_utc: "",
      unixts: 0,
      sdk_ver: globals_1.default.version,
      body: {}
    };
    var now = new Date();
    var localDt = new Date(+now - now.getTimezoneOffset() * 6e4);
    this.header.ts = utils_1.default.toISO8601(localDt);
    this.header.unixts = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()) / 1000;
    this.header.timestamp_utc = utils_1.default.toISO8601(now);
    this.header.uuid = utils_1.default.uuidv4();
    this.header.player_id = utils_1.default.getCookie(utils_1.default.PLAYER_ID_KEY);
    this.header.game_ver = utils_1.default.getCookie(utils_1.default.GAME_VER_KEY);
    this.header.c_session_id = utils_1.default.getClientSessionId();
    this.setSessionRestartedFrom();
    if (utils_1.default.isClient()) {
      var cookie = void 0;
      if (!(cookie = utils_1.default.getCookie(utils_1.default.COOKIE_ID_KEY))) {
        utils_1.default.setCookie(utils_1.default.COOKIE_ID_KEY, cookie = utils_1.default.uuidv4(), 0);
      }
      this.header.device_id = cookie;
    }
    this.setName(name);
    this.setEventBody(body);
    this.SetPlatform(globals_1.default.platform);
  }
  Event.prototype._setTs = function (ts) {
    this.header.ts = ts;
    return this;
  };
  Event.prototype._setUnixts = function (unixts) {
    this.header.unixts = unixts;
    return this;
  };
  Event.prototype._mergeEventBody = function (body) {
    var jsonBody = body.getJson();
    for (var prop in jsonBody) {
      this.eventBody.AddParam(prop, jsonBody[prop]);
    }
  };
  Event.prototype.getEventBody = function () {
    return this.eventBody;
  };
  Event.prototype.setEventBody = function (eventBody) {
    if (eventBody instanceof eventbody_1.default) {
      this.eventBody = eventBody;
    } else {
      this.eventBody = new eventbody_1.default(eventBody);
    }
    return this;
  };
  Event.prototype.toJson = function () {
    try {
      this.header.c_session_id = utils_1.default.getClientSessionId();
      this.header = __assign(__assign({}, this.header), Event.customHeaderParams);
      this.header.body = this.eventBody ? this.eventBody.getJson() : {};
      return this.header;
    } catch (err) {
      logger_1.default.getInstance().add("Event error. Couldn't stringify event. Error says \"" + err + "\"", logLevel_1.default.ERROR);
      return {};
    }
  };
  Event.prototype.SetAppToken = function (app_token) {
    this.header.app_token = app_token;
    return this;
  };
  Event.prototype._isPrefab = function () {
    return false;
  };
  Event.prototype.setSessionRestartedFrom = function () {
    var cSessionRestartedFrom = utils_1.default.getClientSessionRestartedFrom();
    if (cSessionRestartedFrom && cSessionRestartedFrom.length > 0) {
      this.header["c_session_restarted_from"] = cSessionRestartedFrom;
    }
  };
  Event.prototype.setName = function (name) {
    if (!this._isPrefab() && utils_1.default.prefabEvents.indexOf(name) !== -1) {
      throw new Error("An event with the name " + name + " cannot be created because there is a prefab event with the same name. Modify the name or try the prefab.");
    }
    this.header.name = name;
    return this;
  };
  Event.prototype.getName = function () {
    return this.header.name;
  };
  Event.prototype.SetPlayerLevel = function (currentLevel) {
    this.header.level_before = currentLevel;
    return this;
  };
  Event.prototype.GetPlayerLevel = function () {
    return this.header.level_before;
  };
  Event.prototype.SetPlayerXp = function (currentXp) {
    this.header.xp_before = currentXp;
    return this;
  };
  Event.prototype.GetPlayerXp = function () {
    return this.header.xp_before;
  };
  Event.prototype.SetPlayerId = function (player_id) {
    utils_1.default.setCookie(utils_1.default.PLAYER_ID_KEY, player_id, 0);
    this.header.player_id = player_id;
    return this;
  };
  Event.prototype.GetPlayerId = function () {
    return this.header.player_id;
  };
  Event.prototype.SetServerSessionId = function (s_session_id) {
    this.header.s_session_id = s_session_id;
    return this;
  };
  Event.prototype.GetServerSessionId = function () {
    return this.header.s_session_id;
  };
  Event.prototype.SetGameVersion = function (gameVersion) {
    utils_1.default.setCookie(utils_1.default.GAME_VER_KEY, gameVersion, 0);
    this.header.game_ver = gameVersion;
    return this;
  };
  Event.prototype.GetGameVersion = function () {
    return this.header.game_ver;
  };
  Event.prototype.GetClientSessionId = function () {
    return this.header.c_session_id;
  };
  Event.prototype.SetPlatform = function (platform) {
    this.header.platform = platform;
    return this;
  };
  Event.prototype.GetPlatform = function () {
    return this.header.platform;
  };
  Event.prototype.SetEnv = function (env) {
    this.header.env = env;
    return this;
  };
  Event.prototype.getEnv = function () {
    return this.header.env;
  };
  Event.prototype.getUuid = function () {
    return this.header.uuid;
  };
  Event.prototype.getTimezone = function () {
    return this.header.timezone;
  };
  Event.prototype.getUnixts = function () {
    return this.header.unixts;
  };
  Event.prototype.getTs = function () {
    return this.header.ts;
  };
  Event.prototype.getTimestampUTC = function () {
    return this.header.timestamp_utc;
  };
  Event.prototype.addCustomHeader = function (param, value) {
    return this.SetCustomHeaderParam(param, value);
  };
  Event.prototype.SetCustomHeaderParam = function (param, value) {
    this.header[param] = value;
    return this;
  };
  Event.SetCustomHeaderParam = function (param, value) {
    this.customHeaderParams[param] = value;
  };
  Event.ResetCustomHeaders = function () {
    this.customHeaderParams = {};
  };
  Event.customHeaderParams = {};
  return Event;
}();
exports.default = Event;